/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Injectable} from '@angular/core';

import {AngularModalService} from '../common/modal/angular-modal.service';
import {CreativeRetailProductModalComponent} from './creative-retail-product-modal.component';

export interface CreativeRetailProductModalOptions {
  selRetailProduct?: any;
  onSelect: (product: any) => Promise<any> | any;
}

@Injectable({providedIn: 'root'})
export class CreativeRetailProductModalService {
  constructor(private readonly angularModalService: AngularModalService) {
  }

  open(options: CreativeRetailProductModalOptions): void {
    this.angularModalService.show(CreativeRetailProductModalComponent, {
      class: 'modal-lg',
      initialState: {
        selRetailProduct: options.selRetailProduct,
        onSelect: options.onSelect
      }
    });
  }
}
